// extracted by mini-css-extract-plugin
export default {"spaceRight":"App_spaceRight__3cr6V"};